import { render, staticRenderFns } from "./walmartChart.vue?vue&type=template&id=642bdd9e&scoped=true"
import script from "./walmartChart.vue?vue&type=script&lang=js"
export * from "./walmartChart.vue?vue&type=script&lang=js"
import style0 from "./walmartChart.vue?vue&type=style&index=0&id=642bdd9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642bdd9e",
  null
  
)

export default component.exports